import { AsyncSelect, Button, MultiSelectDropDown, SelectDropDown } from '@wot/components';
import { Strengths } from '@wot/shared';
import {
  IGrades,
  IProfessionBoard,
  IProfessionHobby,
  IProfessionSkill,
  IProfessionSubject,
  ITutorProfessionCategory
} from '@wot/typings';
import { useEffect, useState } from 'react';
import categoriesApi from '../../../../api/categories';
import { CLOSE_ICON } from '../../../../assets/icons';
import { toast } from 'react-toastify';

const expOptions = ["1", "2", "3", "4", "5", "more than 5 years"];

interface Props {
  categories?: ITutorProfessionCategory<IProfessionSubject>[];
  handleChange?: (data: ITutorProfessionCategory<IProfessionSubject | IProfessionHobby | IProfessionSkill>[]) => void;
}

export function AddSubject({ categories, handleChange }: Props) {
  const [tempSubjects, setTempSubjects] = useState<ITutorProfessionCategory<IProfessionSubject>[]>(categories || []);

  const handleFormChange = (
    newValues: ITutorProfessionCategory<IProfessionSubject>,
    index?: number,
    remove?: number
  ) => {
    let temp = [...tempSubjects];
    if (index) {
      if (remove) {
        temp = temp.filter((item, idx) => idx !== index - 1);
        setTempSubjects(temp);
        return;
      }
      let stemp = temp.filter((_, i) => i !== index - 1);
      let exists = stemp.filter((s) => s.name == newValues.name).length > 0;
      if (exists) {
        toast.error(`${newValues.name} Subject already added`)
        return true;
      }
      temp[index - 1] = newValues;
      setTempSubjects(temp);
    } else {
      let exists = temp.filter((s) => s.name == newValues.name).length > 0;
      if (exists) {
        toast.error(`${newValues.name} Subject already added`)
        return true;
      }
      temp.push(newValues);
      setTempSubjects(temp);
    }
  };

  useEffect(() => {
    handleChange && handleChange(tempSubjects);
  }, [tempSubjects]);

  return (
    <div className=" w-full h-full flex flex-col md:px-6 bg-white overflow-y-scroll custom-scrollbar pb-20">
      <div className="w-full grow flex flex-col">
        <CurrentSubjectForm handleFormChange={handleFormChange} />
        <div className="flex flex-col gap-5">
          {tempSubjects.map((subject, index) => (
            <SubjectItem subject={subject} handleFormChange={handleFormChange} index={index + 1} key={index + 1} />
          ))}
        </div>
      </div>
    </div>
  );
}

interface FormProps {
  subject: ITutorProfessionCategory<IProfessionSubject>;
  handleFormChange: (v: ITutorProfessionCategory<IProfessionSubject>, index?: number, remove?: number) => void;
  index?: number;
  errors?: SubjectFormError;
}

function CurrentSubjectForm({
  handleFormChange
}: {
  handleFormChange: (v: ITutorProfessionCategory<IProfessionSubject>, index?: number) => void;
}) {
  const [currentSubject, setCurrentSubject] = useState<ITutorProfessionCategory<IProfessionSubject>>({
    name: '',
    board: []
    // experience: 0,
    // strengths: [],
  });

  const [errors, setErrors] = useState<SubjectFormError>();
  const [showNewForm, setShowNewForm] = useState<boolean>(false);

  return (
    <div>
      <div className="w-full flex items-center py-4 justify-between">
        <h1 className="text-xl font-semibold">Subjects</h1>
        <div className="max-w-sm">
          {!showNewForm && (
            <Button
              text="+ Add New Subject"
              onClick={() => {
                setShowNewForm(true);
              }}
            />
          )}
        </div>
      </div>
      {showNewForm && (
        <div className="w-full flex my-5 gap-7 p-4 border border-gray-300 rounded-md">
          {/* <div className="w-full flex items-center justify-between">
        <h1 className="text-xl font-semibold">Subject</h1> */}
          <div className="w-full">
            <div className="flex w-full gap-4">
              <SubjectForm
                name={currentSubject.name}
                setName={(value) => setCurrentSubject({ ...currentSubject, name: value })}
                boardsList={currentSubject.board}
                setBoardsList={(list) => setCurrentSubject({ ...currentSubject, board: list })}
                // experience={currentSubject.experience}
                // setExperience={(value) =>
                //   setCurrentSubject({ ...currentSubject, experience: value })
                // }
                // strengths={currentSubject.strengths}
                // setStrengths={(values) =>
                //   setCurrentSubject({ ...currentSubject, strengths: values })
                // }
                errors={errors}
              />
              <div className="cursor-pointer max-w-xs">
                <img
                  src={CLOSE_ICON}
                  onClick={() => {
                    setShowNewForm(false);
                    setCurrentSubject({
                      name: '',
                      board: []
                      // experience: 0,
                      // strengths: [],
                    });
                    setErrors({});
                  }}
                />
              </div>
              {/* </div> */}
            </div>
            <div className="max-w-[164px] mx-auto mt-5 flex items-center justify-end">
              <Button
                block
                text="Add"
                onClick={() => {
                  if (
                    !currentSubject.name ||
                    !currentSubject.board.length
                    // !currentSubject.strengths.length
                  ) {
                    setErrors({
                      ...errors,
                      name: !currentSubject.name,
                      boards: currentSubject.board.length === 0
                      // strengths: currentSubject.strengths.length === 0,
                      // experience: currentSubject.experience <= 0,
                    });
                    return;
                  }
                  setErrors(undefined);
                  handleFormChange(currentSubject);
                  setCurrentSubject({
                    name: '',
                    board: []
                    // experience: 0,
                    // strengths: [],
                  });
                  setShowNewForm(false);
                }}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function SubjectItem({ subject, handleFormChange, index }: FormProps) {
  const [errors, setErrors] = useState<SubjectFormError>();

  useEffect(() => {
    if (!subject.name || !subject.board.length) {
      setErrors({
        ...errors,
        name: !subject.name,
        boards: subject.board.length === 0
        // strengths: subject.strengths.length === 0,
        // experience: subject.experience <= 0,
      });
      return;
    } else {
      setErrors(undefined);
    }
  }, [subject]);

  return (
    <div className="my-2 border border-gray-300 rounded-md">
      <div className="relativew-full flex flex-col items-start gap-2 md:gap-5 p-4">
        <img
          src={CLOSE_ICON}
          className="w-3 cursor-pointer flex ml-auto"
          onClick={() => handleFormChange(subject, index, 1)}
        />
        <SubjectForm
          name={subject.name}
          setName={(value) => handleFormChange({ ...subject, name: value }, index)}
          boardsList={subject.board}
          setBoardsList={(list) => handleFormChange({ ...subject, board: list }, index)}
          // experience={subject.experience}
          // setExperience={(value) =>
          //   handleFormChange({ ...subject, experience: value }, index)
          // }
          // strengths={subject.strengths}
          // setStrengths={(values) =>
          //   handleFormChange({ ...subject, strengths: values }, index)
          // }
          errors={errors}
        />
      </div>
    </div>
  );
}

interface SubjectFormError {
  name?: boolean;
  boards?: boolean;
}

interface SubjectFormProps {
  name: string;
  setName: (value: string) => void;
  boardsList: IProfessionBoard[];
  setBoardsList: (boards: IProfessionBoard[]) => void;
  errors?: SubjectFormError;
}

function SubjectForm({ name, setName, boardsList, setBoardsList, errors }: SubjectFormProps) {
  const [subjectOptions, setSubjectOptions] = useState<any[]>([]);
  const [gradeOptions, setGradeOptions] = useState<any[]>([]);
  const [boardOptions, setBoardOptions] = useState<string[]>([]);

  useEffect(() => {
    categoriesApi.getCategoriesByType('subject').then((data) => {
      setSubjectOptions(data);
    });
  }, []);

  const handleBoardChange = (newValues: IProfessionBoard, index?: number, remove?: number) => {
    let temp = [...boardsList];
    if (index) {
      if (remove) {
        temp = temp.filter((item, idx) => idx !== index - 1);
        setBoardsList(temp);
        return;
      }
      let stemp = temp.filter((_, i) => i !== index - 1);
      let exists = stemp.filter((s) => s.name == newValues.name).length > 0;
      if (exists) {
        toast.error(`${newValues.name} Board already added`)
        return true;
      }
      temp[index - 1] = newValues;
      setBoardsList(temp);
    } else {
      let exists = temp.filter((s) => s.name == newValues.name).length > 0;
      if (exists) {
        toast.error(`${newValues.name} Board already added`)
        return true;
      }
      temp.push(newValues);
      setBoardsList(temp);
    }
  };

  useEffect(() => {
    if (name) {
      const currentSubject = subjectOptions.find((item: any) => item?.category?.name === name);
      setGradeOptions(currentSubject?.category.grades);
      setBoardOptions(currentSubject?.category.board);
      // setBoardOptions(["CBSE", "ICSE", "State"]);
    }
  }, [name, subjectOptions]);

  return (
    <div className="w-full flex flex-col md:p-3 gap-7">
      <div className="flex flex-col lg:flex-row lg:items-center items-start lg:justify-between gap-2 lg:gap-0">
        <h3 className="w-2/5 text-sm shrink-0">Select Subject</h3>
        <div className="w-full flex flex-col">
          <AsyncSelect
            placeholder={`Select Subject`}
            onChange={(value) => setName(value)}
            callback={async () => {
              const cats = await categoriesApi.getCategoriesByType('subject');
              return cats.map((c: any) => c.category.name);
            }}
            value={name}
            isSearchable
          />
          {errors && errors?.name && (
            <p className="text-xs font-medium text-red-400">Please Select one of the subjects</p>
          )}
        </div>
      </div>
      <CurrentBoardForm handleFormChange={handleBoardChange} gradeOptions={gradeOptions} boardOptions={boardOptions} />
      {boardsList.length > 0 ? (
        <div className="flex flex-col gap-2">
          {boardsList.map((board, index) => (
            <BoardItem
              subjectName={name}
              board={board}
              boardOptions={boardOptions}
              gradeOptions={gradeOptions}
              handleBoardChange={handleBoardChange}
              index={index + 1}
              key={index}
            />
          ))}
        </div>
      ) : (
        <p className="text-sm text-red-600">Please add at least one board</p>
      )}
    </div>
  );
}

interface BoardFormError {
  name?: boolean;
  grades?: boolean;
  strengths: boolean;
  experience: boolean;
}

function CurrentBoardForm({
  handleFormChange,
  boardOptions,
  gradeOptions
}: {
  boardOptions: string[];
  gradeOptions: IGrades[];
  handleFormChange: (newValues: IProfessionBoard, index?: number) => void;
}) {
  const [currentBoard, setCurrentBoard] = useState<IProfessionBoard>({
    name: '',
    grades: [],
    strengths: [],
    experience: ""
  });

  const [errors, setErrors] = useState<BoardFormError>();
  const [showNewForm, setShowNewForm] = useState<boolean>(false);
  return (
    <div className={`w-full flex flex-col ${showNewForm && 'border border-gray-300 bg-neutralGray4 p-4'} rounded-md`}>
      <div className="w-full flex items-start justify-between gap-4">
        {showNewForm && (
          <BoardForm
            subjectName=""
            name={currentBoard.name}
            setName={(value) => setCurrentBoard({ ...currentBoard, name: value })}
            grades={currentBoard.grades}
            setGradesList={(list) => setCurrentBoard({ ...currentBoard, grades: list })}
            gradeOptions={gradeOptions}
            boardOptions={boardOptions}
            experience={currentBoard.experience}
            setExperience={(value) => setCurrentBoard({ ...currentBoard, experience: value })}
            strengths={currentBoard.strengths}
            setStrengths={(values) => setCurrentBoard({ ...currentBoard, strengths: values })}
            error={errors}
          />
        )}
        <div className="max-w-xs">
          {showNewForm ? (
            <div
              className="cursor-pointer"
              onClick={() => {
                setShowNewForm(false);
                setCurrentBoard({
                  name: '',
                  grades: [],
                  experience: "",
                  strengths: []
                });
                setErrors(undefined);
              }}
            >
              <img
                src={CLOSE_ICON}
                onClick={() => {
                  setShowNewForm(false);
                  setCurrentBoard({
                    name: '',
                    grades: [],
                    experience: "",
                    strengths: []
                  });
                  setErrors(undefined);
                }}
              />
            </div>
          ) : (
            <Button
              text="+ Add New Board"
              onClick={() => {
                setShowNewForm(true);
              }}
            />
          )}
        </div>
      </div>

      {showNewForm && (
        <div className="max-w-[164px] mx-auto mt-5 flex items-center justify-end">
          <Button
            block
            text="Add Board"
            onClick={() => {
              if (
                !currentBoard.name ||
                !currentBoard.grades.length ||
                currentBoard.strengths.length == 0 ||
                currentBoard.experience === "0"
              ) {
                setErrors({
                  ...errors,
                  name: !currentBoard.name,
                  grades: currentBoard.grades.length === 0,
                  strengths: currentBoard.strengths.length === 0,
                  experience: !currentBoard.experience
                });
                return;
              }
              setErrors(undefined);
              handleFormChange(currentBoard);
              setCurrentBoard({
                name: '',
                grades: [],
                experience: "",
                strengths: []
              });
              setShowNewForm(false);
            }}
          />
        </div>
      )}
    </div>
  );
}

function BoardItem({
  subjectName,
  board,
  boardOptions,
  gradeOptions,
  handleBoardChange,
  index
}: {
  subjectName: string;
  board: IProfessionBoard;
  boardOptions: string[];
  gradeOptions: IGrades[];
  handleBoardChange: (newValues: IProfessionBoard, index?: number, remove?: number) => void;
  index: number;
}) {
  const [name, setName] = useState(board.name || '');
  const [gradesList, setGradesList] = useState(board.grades || []);
  const [strengths, setStrengths] = useState(board.strengths || []);
  const [experience, setExperience] = useState(board.experience || "");

  useEffect(() => {
    if (index) {
      handleBoardChange(
        {
          name,
          grades: gradesList,
          experience,
          strengths
        },
        index
      );
    } else {
      handleBoardChange({
        name,
        grades: gradesList,
        experience,
        strengths
      });
    }
  }, [name, gradesList, experience, strengths]);
  return (
    <div className="flex flex-col bg-neutralGray4 p-4 border rounded-md items-start gap-4">
      <img
        src={CLOSE_ICON}
        className="w-3 cursor-pointer flex ml-auto"
        onClick={() => handleBoardChange(board, index, 1)}
      />
      <BoardForm
        subjectName={subjectName}
        name={name}
        boardOptions={boardOptions}
        gradeOptions={gradeOptions}
        setName={(value: string) => setName(value)}
        grades={gradesList}
        setGradesList={(list: any[]) => setGradesList(list)}
        experience={experience}
        setExperience={(value: string) => setExperience(value)}
        strengths={strengths}
        setStrengths={(list: string[]) => setStrengths(list)}
      />
    </div>
  );
}
interface BoardFormProps {
  subjectName: string;
  name: string;
  grades: IGrades[];
  boardOptions: any[];
  gradeOptions: IGrades[];
  setName: (value: string) => void;
  setGradesList: (list: IGrades[]) => void;
  strengths: string[];
  setStrengths: (list: string[]) => void;
  experience: string;
  setExperience: (value: string) => void;
  error?: BoardFormError;
}

function BoardForm({
  name,
  grades,
  boardOptions,
  gradeOptions,
  setName,
  setGradesList,
  experience,
  setExperience,
  strengths,
  setStrengths,
  error
}: BoardFormProps) {
  // const [gradeOptions, setGradeOptions] = useState<any[]>([]);

  // useEffect(() => {
  //   boardOptions?.forEach((t) => {
  //     if (t.name === name) setGradeOptions(t.grades);
  //   });
  // }, [name, boardOptions]);
  // console.log(boardOptions);
  return (
    <div className="w-full flex flex-col gap-7">
      <div className="flex flex-col lg:flex-row lg:items-center items-start lg:justify-between gap-2 lg:gap-0">
        <h3 className="w-2/5 text-sm font-medium shrink-0">Board</h3>
        <div className="w-full h-full">
          <div className="w-full flex flex-col">
            <SelectDropDown
              placeholder={`Select a Board`}
              onChange={(value) => setName(value)}
              options={boardOptions}
              value={name}
              isSearchable
            />
            {error && error.name && <p className="text-sm text-red-600">Select a Board</p>}
          </div>
        </div>
      </div>
      <div className="flex flex-col lg:flex-row lg:items-center items-start lg:justify-between gap-2 lg:gap-0">
        <h3 className="w-2/5 text-sm font-medium shrink-0">Grades</h3>
        <div className="w-full h-full">
          <MultiSelectDropDown
            placeholder="Add Grades"
            onChange={(values: any) => setGradesList(values)}
            values={grades!}
            options={gradeOptions}
            selectAll
          />
          {error && error.grades && grades.length === 0 && (
            <p className="text-sm text-red-600">Select at least one Grade</p>
          )}
        </div>
      </div>

      <div className="flex flex-col lg:flex-row lg:items-center items-start lg:justify-between gap-2 lg:gap-0">
        <p className="w-2/5 text-sm font-medium shrink-0">Experience</p>
        <div className="w-full flex flex-col">
          <SelectDropDown
            placeholder="Select Experience"
            value={experience?.toString() || ''}
            options={expOptions.map((i) => i.toString())}
            onChange={(value) => setExperience(value)}
          />
          {error && error?.experience && <p className="text-xs font-medium text-red-400">Please Select Experience</p>}
        </div>
      </div>

      <div className="flex flex-col lg:flex-row lg:items-center items-start gap-2 lg:gap-0">
        <div className="lg:w-2/5 w-full">
          <p className="text-sm font-medium shrink-0">Add Strengths</p>
          <p className="w-full md:w-32 text-xs text-gray-500">
            You can add up to 5 tags. Length limit for each tag is 20 characters.
          </p>
        </div>
        <div className="w-full md:w-3/5 flex flex-col">
          <Strengths values={strengths} handleChange={setStrengths} icon={CLOSE_ICON} />
          {error && error?.strengths && (
            <p className="text-xs font-medium text-red-400">Please Add at least one strength</p>
          )}
        </div>
      </div>
    </div>
  );
}
